

import { useContext, useEffect, useState } from "react";

import globalContext from '../context/context'
import axios from "axios";

function WalletPrice() {
    const { contextData: { user } } = useContext(globalContext);

    const [wallet, setWallet] = useState(null);

    useEffect(() => {
        if(user?.id){
            getWallet();
        }
    }, [user])

    const getWallet = () => {
        if(user?.id){
            axios.get(`/api/customers?userId.equals=${user?.id}`)
            .then(r => {
                if(r?.data&&r?.data[0]){
                    setWallet(r?.data[0]?.walletAmountInEuro)
                }
            })
            .catch(err => console.log(err));
        }

    };

    return (<>EUR {wallet??'0.00'}</>)

}

export default WalletPrice;
